import React from 'react';
import PropTypes from 'prop-types';
import StoryList from './StoryList';
import ContentContainer from '../content/content';

const Stories = ({ handleDeleteStory, stories, activeTab }) => {
  return activeTab === "stories" ?
      <StoryList handleDeleteStory={ handleDeleteStory } stories={ stories } activeTab={ activeTab } /> :
      (activeTab !== 'projects' && activeTab !== 'tools') ? <ContentContainer storyId={ activeTab } /> : null
};

Stories.propTypes = {
  stories: PropTypes.object,
  handleDeleteStory: PropTypes.func,
  activeTab: PropTypes.string
};

export default Stories;



// WEBPACK FOOTER //
// ./src/containers/admin/Stories.js